import axios, { AxiosRequestConfig } from 'axios';
import get from 'lodash/get';
import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';

export const useAppSetting = <T extends unknown>(
  name: string | string[],
  axiosCfg: ExtendedAxiosRequestConfig = {},
  queryOptions: UseQueryOptions<T, Error> = {}
): UseAppSettingResult<T> => {
  const { queryKey = [], ...restQueryOptions } = queryOptions;
  const getResult = useQuery<T, Error>({
    queryKey: ['/appsettings/search', name, ...queryKey].filter(Boolean) as string[],

    queryFn: async (): Promise<T> => {
      const fields = Array.isArray(name) ? name : [name];
      const body = { Intent: '', Fields: fields, Criterion: [], Sort: [], Page: 0, PageSize: 0 };

      const axiosRes = await axios.request<UseGetResponse>({ url: `/appsettings/search`, method: 'POST', data: body, ...axiosCfg });

      if (Array.isArray(name)) return axiosRes.data.Data as T;
      return get(axiosRes.data.Data, name, null) as T;
    },

    retry: false,
    staleTime: 1000 * 60 * 5, // 5 minutes
    ...restQueryOptions,
  });

  return getResult;
};

type UseGetResponse = {
  Data: Record<string, unknown>;
};

type UseAppSettingResult<T> = UseQueryResult<T, Error>;

type ExtendedAxiosRequestConfig = AxiosRequestConfig;
